import axios from "../lib/axios";

export const download = async (data) => {
  try {
    const response = await axios.post("/export/download", data, {
      responseType: "blob",
    });

    // Create blob with correct type
    const blob = new Blob([response.data], {
      type: response.headers["content-type"] || "application/octet-stream",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;

    // Extract filename from Content-Disposition header
    const contentDisposition = response.headers["content-disposition"];
    let fileName = `export_${Date.now()}.${data.format}`;

    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(
        /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
      );
      if (fileNameMatch && fileNameMatch[1]) {
        fileName = fileNameMatch[1].replace(/['"]/g, "");
      }
    }

    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return { success: true, fileName };
  } catch (error) {
    console.error("Download error:", error);
    throw new Error(
      error?.response?.data?.message ||
        error?.message ||
        "Failed to download file"
    );
  }
};
